import React from 'react';
import { Content, Page } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core/styles';

const CALENDAR_URL = "https://outlook.office365.com/owa/calendar/8c75459ebd48489b82bc36adfc184a2b@syntonize.com/6c65181162674a97812956d1ec4853ce14617980489009616320/calendar.html";

const useStyles = makeStyles(theme => ({
  contentContainer: {
    height: 'calc(100vh - 120px)',
    backgroundColor: theme.palette.background.default,
    overflow: 'hidden',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    minHeight: '600px',
  },
}));

const Calendar = () => {
  const classes = useStyles();

  return (
    <Page themeId="tool">
      <Content>
        <div className={classes.contentContainer}>
          <iframe 
            src={CALENDAR_URL}
            className={classes.iframe}
            title="Syntonize Calendar"
            security="restricted"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            scrolling="yes"
            frameBorder="0"
            allowFullScreen
            data-owa="true"
            data-ms-embedded="true"
          />
        </div>
      </Content>
    </Page>
  );
};

export default Calendar;